@if (isVisible) {
  <div
    class="opt-overlay"
    [class.opt--enter]="animationClass === 'opt--enter'"
    [class.opt--exit]="animationClass === 'opt--exit'"
    role="dialog"
    [attr.aria-labelledby]="dialog.title ? 'opt-dialog-title' : null"
    [attr.aria-modal]="true"
    (click)="onBackdropClick()"
  >
    <div
      class="opt-card"
      [class.opt--enter]="animationClass === 'opt--enter'"
      [class.opt--exit]="animationClass === 'opt--exit'"
      (click)="$event.stopPropagation()"
    >
      <div class="opt-content">
        @if (dialog.title) {
          <h2 class="opt-title" id="opt-dialog-title">{{ dialog.title }}</h2>
        }

        <p class="opt-message" [innerHTML]="dialog.message"></p>

        <div class="opt-actions">
          @for (option of options; track option) {
            <button
              type="button"
              class="boton opt-action"
              [ngClass]="getOptionColorClass(option)"
              (click)="onOptionSelect(option.id)"
            >
              {{ option.name || option.keyCode || ('Opción ' + option.id) }}
            </button>
          }
        </div>

        @if (showCancelButton) {
          <button type="button" class="boton opt-cancel" (click)="onCancel()">
            {{ 'Cancelar' }}
          </button>
        }
      </div>
    </div>
  </div>
}
